import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function ExcellenceInPsychiatry() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="excellence-in-psychiatry" className="relative flex min-h-[70vh] flex-col items-center justify-center overflow-hidden bg-secondary px-6 py-24 text-center md:py-32">
      {}
      <div ref={ref} className={cn("relative z-10 mx-auto flex max-w-4xl flex-col items-center gap-8 transition-all duration-1000 ease-out", isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0")}>
        <h2 className="font-serif text-4xl font-medium tracking-tight text-primary md:text-5xl lg:text-6xl">
          Excellence in Psychiatry
        </h2>

        <div className="h-px w-24 bg-primary/20" />

        <p className="mx-auto max-w-[800px] font-sans text-lg leading-relaxed text-muted-foreground md:text-xl md:leading-loose">
          Sharmat Psychiatric Group is a high‑end psychiatric practice that
          combines cutting‑edge genetic evaluation with personalized medication
          management. Led by award‑winning psychiatrist Dr. Sharmat and
          board‑certified nurse practitioner Maryellen Stephens, the team
          delivers compassionate care to all clients regardless of background.
          The practice emphasizes respect, evidence‑based treatment, and a
          down‑to‑earth approach that bridges advanced science with
          patient‑centered empathy.
        </p>
      </div>

      {}
      <div className="absolute bottom-12 left-1/2 flex -translate-x-1/2 flex-col items-center gap-4">
        <span className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground/60">
          Scroll
        </span>
        <div className="flex h-12 w-6 justify-center rounded-full border border-muted-foreground/20 bg-background/50 p-1 backdrop-blur-sm">
          <div className="h-1.5 w-1.5 animate-bounce rounded-full bg-primary" />
        </div>
      </div>

      {}
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute -top-[20%] -right-[10%] h-[500px] w-[500px] rounded-full bg-background/40 blur-3xl" />
        <div className="absolute -bottom-[20%] -left-[10%] h-[500px] w-[500px] rounded-full bg-background/40 blur-3xl" />
      </div>
    </section>;
}